import React, { Component } from 'react';
import instance from "./axios-instance";
import MainSettingContext from './MainSettingContext';
import Systems from "./SystemFunction";
import Swal from 'sweetalert2'
import md5 from 'md5';
import { toast } from 'react-toastify';
import jwt_decode from 'jwt-decode';
import { t } from './i18n';
class App extends Component {
    static contextType = MainSettingContext;
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: false,
            pagecount: 1,
            playerid: null,
            user_id: null,
            point: props.point || null,
            products_page_count: 1,
            loginstate: props.loginstate || false,
            firstname: null,
            lastname: null,
            alert: null,
            username: props.username || "",
            userid: props.userid || null,
            balance: props.balance || 0,
            tblprofile: props.tblprofile || null,
            sumcash: 0,
            usercashoutlist: [],
            rankpic: props.rankpic || "1.jpeg",
            rankname: props.rankname || null,
            rankob: props.rankob || null,
            rankpoint: props.rankpoint || 0,
            linkaff: props.linkaff || "",
            linelink: props.linelink || "",
            maxwithdrawstatus: props.maxwithdrawstatus || null,
            webnamex: props.webnamex || "",
            cashoutSet: props.cashoutSet || null,
            inviteSet: props.inviteSet || null,
            typeinvite: props.inviteSet ? props.inviteSet.caltype : 0,
            limit: props.limit || {},
        }
        this.handleClick = this.handleClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.hideAlert = this.hideAlert.bind(this);

    }
    get lang() {
        return this.props.language || this.context?.language || localStorage.getItem('lang') || 'th';
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });

        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: 0,
                    page: pageNumber
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
    }

    handleClick = async (e) => {
        this.setState({
            activePage: 1,
            isActive: true,
            activeTab: 0
        });
        instance.get("/api/v1/rewardlist", {
            params: {
                Cat_ID: e.target.id,
                page: 1
            }
        })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
        this.setState({
            isActive: false
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    notify = async (mode, msg) => {
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    waitnotify = async () => {
    }
    async opencliamcashout(evt, cityName) {

        var token = localStorage.getItem('auth_token');

        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/cliamcashout", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    this.rechecklogin(Username, token);
                    await this.notify("success", t(this.lang, 'cashback_success_notify'));
                }
                else if (res.data.status === 201) {
                    await this.notify("error", t(this.lang, 'cashback_no_balance'));
                    return false;
                }
                else if (res.data.status === 202) {
                    await this.notify("error", t(this.lang, 'cashback_failed'));
                    return false;
                }

            }).catch(async (err) => {
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }
            });
        } else {
            await this.notify("error", t(this.lang, 'not_logged_in'));
        }
    }
   rechecklogin = async (Username, token) => {
        try {

            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            const space = window.location.host
            var userhash = md5(Username);
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Update: userhash,
                Function: 'rechecklogin-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    const rankall = res.data.tblrankall || [];
                    const found = rankall.find(obj => {
                        return obj.checked === 1;
                    });

                    const cashoutList = res.data.usercashoutlist || [];
                    let sumcash = 0;
                    for (let x = 0; x < cashoutList.length; x++) {
                        sumcash += Number(cashoutList[x].amount) || 0;
                    }
                    this.setState({
                        tblrankall: res.data.tblrankall,
                        linkaff: linkaff,
                        buttoncliam: (found === undefined) ? true : false,
                        tblnextrank: res.data.tblnextrank,
                        rankpic: res.data.tblrank ? ((res.data.tblrank.image == null || res.data.tblrank.image == "") ? "https://apixgen.javisx.com/build/rank/1.jpeg" : (res.data.tblrank.picrack == null || res.data.tblrank.picrack == "") ? "https://apixgen.javisx.com/build/rank/" + res.data.tblrank.image : res.data.tblrank.picrack) : "https://apixgen.javisx.com/build/rank/1.jpeg",
                        rankname: res.data.tblrank ? res.data.tblrank.name : null,
                        rankob: res.data.tblrank || null,
                        tblprofile: res.data.message || null,
                        usercashoutlist: cashoutList,
                        sumcash: sumcash,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message ? res.data.message.accnumber : null,
                        userid: res.data.message ? res.data.message.member_id : null,
                        username: res.data.message ? res.data.message.playerid : null,
                        fullname: res.data.message ? res.data.message.firstname : null,
                        point: res.data.message ? res.data.message.Point : null,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: t(this.lang, 'session_expired'),
                        icon: 'warning',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
        }

    }

    async componentDidMount() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
        }
        if (this.props.linelink) {
            this.setState({
                linelink: this.props.linelink,
                maxwithdrawstatus: this.props.maxwithdrawstatus,
                webnamex: this.props.webnamex,
                cashoutSet: this.props.cashoutSet,
                inviteSet: this.props.inviteSet,
                typeinvite: this.props.inviteSet ? this.props.inviteSet.caltype : 0,
                limit: this.props.limit || {},
            });
        } else {
            const data = this.context;
            if (data) {
                const datas = data.message;
                const cat0 = data.tblcatagoryx && data.tblcatagoryx[0];
                const limit = cat0
                    ? { min: cat0.limitdeposit, max: cat0.maxdeposit }
                    : { min: 0, max: 0 };
                const caltype = data.tblinvitedsetting?.length > 0 ? data.tblinvitedsetting[0].caltype : 0;
                this.setState({
                    maxwithdrawstatus: cat0 ? cat0.withdrawmax : 0,
                    linelink: datas && datas[1] ? datas[1].value : '',
                    webnamex: datas && datas[7] ? datas[7].value : '',
                    cashoutSet: data.tblcashoutsetting && data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting && data.tblinvitedsetting[0],
                    typeinvite: caltype,
                    datas,
                    limit,
                });
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loginstate !== this.props.loginstate ||
            prevProps.balance !== this.props.balance ||
            prevProps.point !== this.props.point) {
            if (this.props.loginstate && this.props.username) {
                this.setState({
                    loginstate: this.props.loginstate,
                    username: this.props.username,
                    userid: this.props.userid,
                    balance: this.props.balance,
                    point: this.props.point,
                    tblprofile: this.props.tblprofile,
                    rankpic: this.props.rankpic,
                    rankname: this.props.rankname,
                    rankob: this.props.rankob,
                    rankpoint: this.props.rankpoint,
                    linkaff: this.props.linkaff,
                    linelink: this.props.linelink || this.state.linelink,
                    maxwithdrawstatus: this.props.maxwithdrawstatus || this.state.maxwithdrawstatus,
                    webnamex: this.props.webnamex || this.state.webnamex,
                    cashoutSet: this.props.cashoutSet || this.state.cashoutSet,
                    inviteSet: this.props.inviteSet || this.state.inviteSet,
                    limit: this.props.limit || this.state.limit,
                });
            }
        }
    }

    render() {
        const lang = this.props.language || this.context?.language || 'th';
        const { cashoutSet, typeinvite, inviteSet, loginstate, trueaccount, webnamex, stateopterror, changepassword, username, balance, accnumber, fullname, mainacc, limit, rankob, rankpoint, tblnextrank, userrecomend, linkaff, tblprofile, proderedeem, proderedeemlist, prodetail } = this.state

        return (
            <>

                <div className="container p-0 x-margin-top-v3">
                    <div className="row m-0 border-shadow-title">
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web">
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-between">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" href='/'>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={25}
                                                        height={25}
                                                        fill="currentColor"
                                                        className="bi bi-arrow-left-circle text-white"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                        />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <h5>{t(lang, 'cashback_title')}</h5>
                                            </div>
                                            <div>{/**/}</div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>
                            <div className="p-2 bg-profile-box-overview">
                                {/**/}
                        
                                <div
                                    data-v-ab1d19ba=""
                                    className="auction animated animatedFadeInUp fadeInUp"
                                    role="button"
                                >
                                    {/* ยอดคืนเงิน */}
                                    <div className="bg-profile-box-overview p-2 mt-2">
                                        <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                            <div className="align-self-center">
                                                <div className="p-1 text-left">
                                                    <small className="credit-bl-text">
                                                        {t(lang, 'loss_calculated_title')}
                                                        {cashoutSet != null ? (
                                                            <span className="badge ms-1" style={{ background: "#444" }}>
                                                                {cashoutSet.type === 1 ? t(lang, 'daily_type') : cashoutSet.type === 2 ? t(lang, 'weekly_type') : cashoutSet.type === 3 ? t(lang, 'monthly_type') : ""}
                                                            </span>
                                                        ) : null}
                                                    </small>
                                                    <div>
                                                        <h3 className="m-0"><b className="p-1">{Number(this.state.sumcash).toFixed(2)}</b></h3>
                                                    </div>
                                                    {cashoutSet?.NextRound ? (
                                                        <small className="credit-bl-text" style={{ opacity: 0.7 }}>
                                                            {t(lang, 'next_round_prefix')} {cashoutSet.NextRound.toString().substring(0, 10)}
                                                        </small>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="align-self-center text-right">
                                                <div><small className="credit-bl-text">{t(lang, 'cashback_rate')}</small></div>
                                                <span className="badge text-bg-dark">{(cashoutSet != null) ? cashoutSet.percent : 0}%</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-profile-box-overview p-2 mt-2">
                                        <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                            <div className="align-self-center">
                                                <div className="p-1 text-left">
                                                    <small className="credit-bl-text">{t(lang, 'total_receivable_cashback')}</small>
                                                    <div>
                                                        <h3 className="m-0"><b className="p-1">{tblprofile?.Cashtotal ?? 0}</b></h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* ปุ่มถอน */}
                                    <div className="mt-2 animated animatedFadeInUp fadeInUp">
                                        <div className="elementor-element-play-overview p-2">
                                            <div className="d-flex align-items-center mb-2">
                                                <img
                                                    className="logo-profile-user-w p-1"
                                                    src="/images/cdn/48a22d9a-8abe-477f-0f40-57204ce17700.png"
                                                    alt=""
                                                />
                                                <div className="ms-1">
                                                    <small className="credit-bl-text">{t(lang, 'withdrawable_cashback')}</small>
                                                    <div><b className="font-aff-wid" style={{ fontSize: "1.2rem" }}>{tblprofile?.Cashtotal ?? 0}</b> <small className="credit-bl-text">{t(lang, 'baht')}</small></div>
                                                </div>
                                            </div>
                                            <a role="button" onClick={(e) => { this.opencliamcashout(e, 'bonusrankaccount'); }} style={{ display: "block" }}>
                                                <div className="btn w-100 p-3" style={{ background: "linear-gradient(135deg,#f6a200,#e67e00)", color: "#fff", fontWeight: "bold", fontSize: "1rem", borderRadius: "8px" }}>
                                                    <img
                                                        className="wid-button p-1"
                                                        src="/images/cdn/de26db72-10a7-4369-5e7e-dd07d4568300.png"
                                                        alt=""
                                                    />
                                                    {t(lang, 'receive_cashback')}
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-2 text-left mt-4 mb-1 animated animatedFadeInUp fadeInUp credit-bl-text">
                                    {t(lang, 'cashback_title')}
                                </div>
                                <div className="animated animatedFadeInUp fadeInUp">
                                    {this.state.usercashoutlist && this.state.usercashoutlist.length > 0 ? (
                                        <table className="table mb-0">
                                            <thead className="table-dark-history">
                                                <tr className="bg-table-dark-history-title">
                                                    <td className="credit-bl-text"><small>{t(lang, 'date_col')}</small></td>
                                                    <td className="credit-bl-text text-center"><small>{t(lang, 'amount_col')}</small></td>
                                                    <td className="credit-bl-text text-center"><small>{t(lang, 'status_col')}</small></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.usercashoutlist.map((item, idx) => (
                                                    <tr key={idx} className="bg-table-dark-history">
                                                        <td className="credit-bl-text"><small>{item.DateCreate ? item.DateCreate.substring(0, 10) : "-"}</small></td>
                                                        <td className="credit-bl-text text-center"><small>{Number(item.amount || 0).toFixed(2)}</small></td>
                                                        <td className="text-center">
                                                            <span className="badge bg-success"><small>{t(lang, 'status_approve')}</small></span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                            <img
                                                className="load-history"
                                                src="/images/cdn/e4ac87bf-3687-4f37-c96e-6ad9e797bf00.png"
                                                alt=""
                                            />
                                            <div className="not-history font-history-menu-text p-2">
                                                <small><b>{t(lang, 'no_data')}</b></small>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        );
    }
}
export default App;
